import React from 'react';
import { Badge, Card } from 'react-bootstrap';
import { Event } from '../../types/event';
import { MediaCard } from '../common/MediaCard';

interface EventCardProps {
    event: Event;
    onClick: () => void;
}

const EventCard: React.FC<EventCardProps> = ({ event, onClick }) => {
    const formatDate = (dateString: string | null): string => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    };

    const getEventStatus = (): { label: string; variant: string } => {
        if (!event.start_at && !event.ends_at) {
            return { label: '', variant: '' };
        }

        const now = new Date();
        const startAt = event.start_at ? new Date(event.start_at) : null;
        const endsAt = event.ends_at ? new Date(event.ends_at) : null;

        if (endsAt && now > endsAt) {
            return { label: 'Completed', variant: 'secondary' };
        }
        if (startAt && now < startAt) {
            return { label: 'Upcoming', variant: 'info' };
        }
        if (startAt && (!endsAt || now <= endsAt)) {
            return { label: 'Active', variant: 'success' };
        }

        return { label: '', variant: '' };
    };

    const status = getEventStatus();

    return (
        <MediaCard
            title={event.name}
            imageAlt={event.name}
            onClick={onClick}
            topLeft={
                event.is_public && (
                    <Badge bg="primary" className="text-uppercase" style={{ letterSpacing: '0.03em' }}>
                        Public
                    </Badge>
                )
            }
            topRight={status.label && <Badge bg={status.variant}>{status.label}</Badge>}
        >
            {(event.start_at || event.ends_at) && (
                <Card.Text className="text-muted small mt-auto" style={{ fontSize: '0.8rem' }}>
                    {event.start_at && formatDate(event.start_at)}
                    {event.start_at && event.ends_at && ' - '}
                    {event.ends_at && formatDate(event.ends_at)}
                </Card.Text>
            )}
        </MediaCard>
    );
};

export default EventCard;
